const styles = ({ palette }) => ({
  letter: {
    display: "inline-block",
  },
});

export default styles;
